import { useState, useCallback } from "react";
import { Nav } from "@/components/laa/Nav";
import { Hero, CredibilityStrip, WhyAppraisal, AuthServices, BrandProtection, Categories } from "@/components/laa/Sections";
import { AppraisalRedirectSection, ContactSection } from "@/components/laa/Forms";
import { About, BrandsShowcase, Footer } from "@/components/laa/AboutBrands";

export default function Home() {
  const [prefillMessage, setPrefillMessage] = useState(null);

  const handleSelectCategory = useCallback((name) => {
    setPrefillMessage(`Hello — I'd like to enquire about an appraisal/authentication for my ${name} item.`);
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="bg-[color:var(--laa-ink)] text-[color:var(--laa-ivory)] min-h-screen">
      <Nav />
      <main>
        <Hero />
        <CredibilityStrip />
        <WhyAppraisal />
        <AuthServices />
        <BrandProtection />
        <Categories onSelectCategory={handleSelectCategory} />
        <AppraisalRedirectSection />
        <About />
        <BrandsShowcase />
        <ContactSection prefillMessage={prefillMessage} />
      </main>
      <Footer />
    </div>
  );
}
